<div class="container-fluid ops-sin-poligono">
  <h1 class="responsive-heading">OPS Y SERVICIOS SIN POLÍGONO</h1>

  <mat-tab-group animationDuration="200ms" class="ops-tabs">

    <!-- ══════════════════════════════════════════════════════════════════════
         TAB 1 ─ OPS SIN POLÍGONO
    ══════════════════════════════════════════════════════════════════════ -->
    <mat-tab label="OPS SIN POLÍGONO">
      <ng-template matTabContent>

        <!-- Filtros principales -->
        <div class="card mb-3 mt-3">
          <div class="alert alert-info mt-2 mb-0 mx-0"><strong>Filtros principales</strong></div>
          <div class="card-body py-2">
            <div class="row align-items-center">

              <!-- Bodega -->
              <div class="col-lg-4 col-md-6 col-sm-12 mb-2">
                <mat-form-field appearance="outline" class="w-100 small-form-field">
                  <mat-label>Bodega</mat-label>
                  <input type="text" matInput [formControl]="filtroBodega1"
                         [matAutocomplete]="autoBodega1" placeholder="Buscar bodega...">
                  <mat-autocomplete #autoBodega1="matAutocomplete"
                                    [displayWith]="displayBodega"
                                    (optionSelected)="onBodega1Selected($event)">
                    <mat-option *ngFor="let b of bodegasFiltradas1 | async" [value]="b">
                      {{ b.cod }} - {{ b.nombre }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>

              <!-- Fecha Inicio -->
              <div class="col-lg-3 col-md-6 col-sm-12 mb-2">
                <mat-form-field appearance="outline" class="w-100 small-form-field">
                  <mat-label>Fecha inicio</mat-label>
                  <input matInput [matDatepicker]="picker1a"
                         [formControl]="fechaInicio1Control"
                         (dateChange)="onFechaInicio1Change()">
                  <mat-datepicker-toggle matSuffix [for]="picker1a"></mat-datepicker-toggle>
                  <mat-datepicker #picker1a></mat-datepicker>
                </mat-form-field>
              </div>

              <!-- Fecha Fin -->
              <div class="col-lg-3 col-md-6 col-sm-12 mb-2">
                <mat-form-field appearance="outline" class="w-100 small-form-field">
                  <mat-label>Fecha fin (máx. 8 días)</mat-label>
                  <input matInput [matDatepicker]="picker1b"
                         [formControl]="fechaFin1Control"
                         [min]="fechaInicio1Control.value"
                         [max]="maxFechaFin1">
                  <mat-datepicker-toggle matSuffix [for]="picker1b"></mat-datepicker-toggle>
                  <mat-datepicker #picker1b></mat-datepicker>
                </mat-form-field>
              </div>

              <!-- Botones Buscar / Limpiar -->
              <div class="col-lg-2 col-md-6 col-sm-12 mb-2 d-flex gap-2">
                <button class="btn btn-info btn-sm flex-fill" (click)="buscar1()">
                  <mat-icon class="small-icon">search</mat-icon> Buscar
                </button>
                <button class="btn btn-outline-secondary btn-sm flex-fill" (click)="limpiar1()">
                  <mat-icon class="small-icon">clear</mat-icon> Limpiar
                </button>
              </div>

            </div>
          </div>
        </div>

        <!-- Filtros opcionales -->
        <div class="card mb-3">
          <div class="alert alert-secondary mt-2 mb-0 d-flex justify-content-between align-items-center">
            <strong>Filtros opcionales</strong>
            <button *ngIf="hayFiltros1" class="btn btn-outline-secondary btn-sm"
                    (click)="limpiarFiltros1()">
              <mat-icon class="small-icon">clear</mat-icon> Limpiar
            </button>
          </div>
          <div class="card-body py-2">
            <div class="row">

              <!-- Departamento -->
              <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                <mat-form-field appearance="outline" class="w-100 small-form-field">
                  <mat-label>Departamento</mat-label>
                  <mat-select multiple [(ngModel)]="depSel1" (ngModelChange)="aplicarFiltros1()">
                    <mat-select-trigger>
                      <ng-container *ngIf="depSel1.length === 0">Seleccione...</ng-container>
                      <ng-container *ngIf="depSel1.length === 1">{{ getNombreDepartamento(depSel1[0]) }}</ng-container>
                      <ng-container *ngIf="depSel1.length > 1">
                        {{ getNombreDepartamento(depSel1[0]) }}
                        <span class="trigger-extra">(+{{ depSel1.length - 1 }} más)</span>
                      </ng-container>
                    </mat-select-trigger>
                    <mat-option disabled class="search-option">
                      <input class="select-search-input" placeholder="Buscar departamento..."
                             [(ngModel)]="filtroDepto1" [ngModelOptions]="{standalone: true}"
                             (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                    </mat-option>
                    <mat-option *ngFor="let d of depFiltrados1" [value]="d.CODIGO_DEPARTAMENTO">
                      {{ d.NOMBRE_DEPARTAMENTO }}
                    </mat-option>
                  </mat-select>
                  <mat-hint *ngIf="depSel1.length > 0">{{ depSel1.length }} seleccionado(s)</mat-hint>
                </mat-form-field>
              </div>

              <!-- Municipio -->
              <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                <mat-form-field appearance="outline" class="w-100 small-form-field">
                  <mat-label>Municipio</mat-label>
                  <mat-select multiple [(ngModel)]="munSel1" (ngModelChange)="aplicarFiltros1()">
                    <mat-select-trigger>
                      <ng-container *ngIf="munSel1.length === 0">Seleccione...</ng-container>
                      <ng-container *ngIf="munSel1.length === 1">{{ getNombreMunicipio(munSel1[0]) }}</ng-container>
                      <ng-container *ngIf="munSel1.length > 1">
                        {{ getNombreMunicipio(munSel1[0]) }}
                        <span class="trigger-extra">(+{{ munSel1.length - 1 }} más)</span>
                      </ng-container>
                    </mat-select-trigger>
                    <mat-option disabled class="search-option">
                      <input class="select-search-input" placeholder="Buscar municipio..."
                             [(ngModel)]="filtroMun1" [ngModelOptions]="{standalone: true}"
                             (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                    </mat-option>
                    <mat-option *ngFor="let m of munFiltrados1" [value]="m.CODIGO_MUNICIPIO">
                      {{ m.NOMBRE_MUNICIPIO }}
                      <small class="text-muted ms-1">({{ m.CODIGO_DEPARTAMENTO }})</small>
                    </mat-option>
                  </mat-select>
                  <mat-hint *ngIf="munSel1.length > 0">{{ munSel1.length }} seleccionado(s)</mat-hint>
                </mat-form-field>
              </div>

            </div>
          </div>
        </div>

        <!-- Barra asignación masiva Tab 1 -->
        <div class="card mb-3 bulk-bar" *ngIf="selection1.selected.length > 0">
          <div class="card-body py-2">
            <div class="row align-items-center">
              <div class="col-auto">
                <span class="badge bg-info text-dark">{{ selection1.selected.length }} OP(s) seleccionada(s)</span>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-12">
                <mat-form-field appearance="outline" class="w-100 small-form-field">
                  <mat-label>Buscar polígono...</mat-label>
                  <input matInput [(ngModel)]="busquedaPoligono1">
                  <mat-icon matSuffix *ngIf="busquedaPoligono1" (click)="busquedaPoligono1=''" class="clear-icon">close</mat-icon>
                </mat-form-field>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12">
                <mat-form-field appearance="outline" class="w-100 small-form-field">
                  <mat-label>Polígono a asignar</mat-label>
                  <mat-select [formControl]="poligonoMasivo1Ctrl">
                    <mat-option [value]="null">-- Seleccione --</mat-option>
                    <mat-option *ngFor="let p of poligonosFiltrados1" [value]="p.ID_POLI">
                      {{ p.COD_POLIGONO }} - {{ p.NOMBRE_POLIGONO }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-auto d-flex gap-2">
                <button class="btn btn-success btn-sm" (click)="asignarMasivo1()">
                  <mat-icon class="small-icon">assignment</mat-icon> Asignar
                </button>
                <button class="btn btn-outline-secondary btn-sm" (click)="limpiarMasivo1()">
                  <mat-icon class="small-icon">clear</mat-icon> Limpiar
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Tabla Tab 1 -->
        <div class="card mb-4" *ngIf="dataSource1.data.length > 0 || dataOriginal1.length > 0">
          <div class="card-body p-0">
            <div class="table-responsive">
              <table mat-table [dataSource]="dataSource1" matSort #sort1="matSort" class="w-100 ops-table">

                <ng-container matColumnDef="select">
                  <th mat-header-cell *matHeaderCellDef class="col-check">
                    <mat-checkbox (change)="toggleAll1()"
                                  [checked]="isAllSelected1()"
                                  [indeterminate]="selection1.selected.length > 0 && !isAllSelected1()">
                    </mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let row" class="col-check">
                    <mat-checkbox (click)="$event.stopPropagation()"
                                  (change)="$event ? selection1.toggle(row) : null"
                                  [checked]="selection1.isSelected(row)">
                    </mat-checkbox>
                  </td>
                </ng-container>

                <ng-container matColumnDef="FECHA_PICKING">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha Picking</th>
                  <td mat-cell *matCellDef="let row">{{ formatearFechaDisplay(row.FECHA_PICKING) }}</td>
                </ng-container>

                <ng-container matColumnDef="NUM_ORDEN">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Num. Orden</th>
                  <td mat-cell *matCellDef="let row">{{ row.NUM_ORDEN || '-' }}</td>
                </ng-container>

                <ng-container matColumnDef="PEDIDO_SAP">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Pedido SAP</th>
                  <td mat-cell *matCellDef="let row">{{ row.PEDIDO_SAP || '-' }}</td>
                </ng-container>

                <ng-container matColumnDef="DEPARTAMENTO">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Departamento</th>
                  <td mat-cell *matCellDef="let row">{{ row.DEPARTAMENTO || '-' }}</td>
                </ng-container>

                <ng-container matColumnDef="MUNICIPIO">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Municipio</th>
                  <td mat-cell *matCellDef="let row">{{ row.MUNICIPIO || '-' }}</td>
                </ng-container>

                <ng-container matColumnDef="CODIGO_ZONA_SAP">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Zona SAP</th>
                  <td mat-cell *matCellDef="let row">{{ row.CODIGO_ZONA_SAP || '-' }}</td>
                </ng-container>

                <ng-container matColumnDef="BARRIO">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Barrio</th>
                  <td mat-cell *matCellDef="let row">{{ row.BARRIO || '-' }}</td>
                </ng-container>

                <ng-container matColumnDef="TIPO_ORDEN">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo Orden</th>
                  <td mat-cell *matCellDef="let row">
                    <span class="badge-tipo">{{ row.TIPO_ORDEN || '-' }}</span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="poligono">
                  <th mat-header-cell *matHeaderCellDef>Polígono</th>
                  <td mat-cell *matCellDef="let row" class="col-poligono" (click)="$event.stopPropagation()">
                    <div class="d-flex align-items-center gap-1">
                      <mat-form-field appearance="outline" class="poligono-select small-form-field">
                        <mat-select [(ngModel)]="row.poligonoAsignado" placeholder="Asignar...">
                          <mat-option [value]="null">-- Sin asignar --</mat-option>
                          <mat-option *ngFor="let p of poligonos" [value]="p.ID_POLI">
                            {{ p.COD_POLIGONO }} - {{ p.NOMBRE_POLIGONO }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <button class="btn btn-success btn-sm btn-guardar"
                              [disabled]="!row.poligonoAsignado"
                              (click)="guardarIndividual1(row)" title="Guardar">
                        <mat-icon class="small-icon">save</mat-icon>
                      </button>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="cols1; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: cols1;"
                    [class.row-selected]="selection1.isSelected(row)"
                    (click)="selection1.toggle(row)"></tr>
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell text-center py-3" [attr.colspan]="cols1.length">
                    No se encontraron OPs con los filtros aplicados.
                  </td>
                </tr>
              </table>
            </div>
            <mat-paginator #paginator1 [pageSizeOptions]="[10, 25, 50, 100]"
                           showFirstLastButtons class="paginator-small">
            </mat-paginator>
          </div>
        </div>

        <!-- Estado vacío Tab 1 -->
        <div class="card mb-3" *ngIf="dataSource1.data.length === 0 && dataOriginal1.length === 0">
          <div class="card-body text-center py-5 text-muted">
            <mat-icon class="empty-icon">search</mat-icon>
            <p class="mt-2">Seleccione bodega y rango de fechas, luego presione <strong>Buscar</strong>.</p>
          </div>
        </div>

      </ng-template>
    </mat-tab>

    <!-- ══════════════════════════════════════════════════════════════════════
         TAB 2 ─ OPS POR POLÍGONO
    ══════════════════════════════════════════════════════════════════════ -->
    <mat-tab label="CAMBIAR POLÍGONOS OPS">
      <ng-template matTabContent>

        <!-- Filtros principales -->
        <div class="card mb-3 mt-3">
          <div class="alert alert-info mt-2 mb-0"><strong>Filtros principales</strong></div>
          <div class="card-body py-2">
            <div class="row align-items-center">

              <!-- Polígono a consultar -->
              <div class="col-lg-4 col-md-6 col-sm-12 mb-2">
                <mat-form-field appearance="outline" class="w-100 small-form-field">
                  <mat-label>Polígono</mat-label>
                  <input type="text" matInput [formControl]="filtroPoligonoCtrl"
                         [matAutocomplete]="autoPoli" placeholder="Buscar polígono...">
                  <mat-autocomplete #autoPoli="matAutocomplete"
                                    [displayWith]="displayPoligono"
                                    (optionSelected)="onPoligonoQuerySelected($event)">
                    <mat-option *ngFor="let p of poligonoQueryFiltrado | async" [value]="p">
                      {{ p.COD_POLIGONO }} - {{ p.NOMBRE_POLIGONO }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>

              <!-- Fecha Inicio -->
              <div class="col-lg-3 col-md-6 col-sm-12 mb-2">
                <mat-form-field appearance="outline" class="w-100 small-form-field">
                  <mat-label>Fecha inicio</mat-label>
                  <input matInput [matDatepicker]="picker2a"
                         [formControl]="fechaInicio2Control"
                         (dateChange)="onFechaInicio2Change()">
                  <mat-datepicker-toggle matSuffix [for]="picker2a"></mat-datepicker-toggle>
                  <mat-datepicker #picker2a></mat-datepicker>
                </mat-form-field>
              </div>

              <!-- Fecha Fin -->
              <div class="col-lg-3 col-md-6 col-sm-12 mb-2">
                <mat-form-field appearance="outline" class="w-100 small-form-field">
                  <mat-label>Fecha fin (máx. 8 días)</mat-label>
                  <input matInput [matDatepicker]="picker2b"
                         [formControl]="fechaFin2Control"
                         [min]="fechaInicio2Control.value"
                         [max]="maxFechaFin2">
                  <mat-datepicker-toggle matSuffix [for]="picker2b"></mat-datepicker-toggle>
                  <mat-datepicker #picker2b></mat-datepicker>
                </mat-form-field>
              </div>

              <!-- Botones Buscar / Limpiar -->
              <div class="col-lg-2 col-md-6 col-sm-12 mb-2 d-flex gap-2">
                <button class="btn btn-info btn-sm flex-fill" (click)="buscar2()">
                  <mat-icon class="small-icon">search</mat-icon> Buscar
                </button>
                <button class="btn btn-outline-secondary btn-sm flex-fill" (click)="limpiar2()">
                  <mat-icon class="small-icon">clear</mat-icon> Limpiar
                </button>
              </div>

            </div>
          </div>
        </div>

        <!-- Filtros opcionales Tab 2 -->
        <div class="card mb-3">
          <div class="alert alert-secondary mt-2 mb-0 d-flex justify-content-between align-items-center">
            <strong>Filtros opcionales</strong>
            <button *ngIf="hayFiltros2" class="btn btn-outline-secondary btn-sm"
                    (click)="limpiarFiltros2()">
              <mat-icon class="small-icon">clear</mat-icon> Limpiar
            </button>
          </div>
          <div class="card-body py-2">
            <div class="row">

              <!-- Departamento -->
              <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                <mat-form-field appearance="outline" class="w-100 small-form-field">
                  <mat-label>Departamento</mat-label>
                  <mat-select multiple [(ngModel)]="depSel2" (ngModelChange)="aplicarFiltros2()">
                    <mat-select-trigger>
                      <ng-container *ngIf="depSel2.length === 0">Seleccione...</ng-container>
                      <ng-container *ngIf="depSel2.length === 1">{{ getNombreDepartamento(depSel2[0]) }}</ng-container>
                      <ng-container *ngIf="depSel2.length > 1">
                        {{ getNombreDepartamento(depSel2[0]) }}
                        <span class="trigger-extra">(+{{ depSel2.length - 1 }} más)</span>
                      </ng-container>
                    </mat-select-trigger>
                    <mat-option disabled class="search-option">
                      <input class="select-search-input" placeholder="Buscar departamento..."
                             [(ngModel)]="filtroDepto2" [ngModelOptions]="{standalone: true}"
                             (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                    </mat-option>
                    <mat-option *ngFor="let d of depFiltrados2" [value]="d.CODIGO_DEPARTAMENTO">
                      {{ d.NOMBRE_DEPARTAMENTO }}
                    </mat-option>
                  </mat-select>
                  <mat-hint *ngIf="depSel2.length > 0">{{ depSel2.length }} seleccionado(s)</mat-hint>
                </mat-form-field>
              </div>

              <!-- Municipio -->
              <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                <mat-form-field appearance="outline" class="w-100 small-form-field">
                  <mat-label>Municipio</mat-label>
                  <mat-select multiple [(ngModel)]="munSel2" (ngModelChange)="aplicarFiltros2()">
                    <mat-select-trigger>
                      <ng-container *ngIf="munSel2.length === 0">Seleccione...</ng-container>
                      <ng-container *ngIf="munSel2.length === 1">{{ getNombreMunicipio(munSel2[0]) }}</ng-container>
                      <ng-container *ngIf="munSel2.length > 1">
                        {{ getNombreMunicipio(munSel2[0]) }}
                        <span class="trigger-extra">(+{{ munSel2.length - 1 }} más)</span>
                      </ng-container>
                    </mat-select-trigger>
                    <mat-option disabled class="search-option">
                      <input class="select-search-input" placeholder="Buscar municipio..."
                             [(ngModel)]="filtroMun2" [ngModelOptions]="{standalone: true}"
                             (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                    </mat-option>
                    <mat-option *ngFor="let m of munFiltrados2" [value]="m.CODIGO_MUNICIPIO">
                      {{ m.NOMBRE_MUNICIPIO }}
                      <small class="text-muted ms-1">({{ m.CODIGO_DEPARTAMENTO }})</small>
                    </mat-option>
                  </mat-select>
                  <mat-hint *ngIf="munSel2.length > 0">{{ munSel2.length }} seleccionado(s)</mat-hint>
                </mat-form-field>
              </div>

            </div>
          </div>
        </div>

        <!-- Barra reasignación masiva Tab 2 -->
        <div class="card mb-3 bulk-bar bulk-bar--modify" *ngIf="selection2.selected.length > 0">
          <div class="card-body py-2">
            <div class="row align-items-center">
              <div class="col-auto">
                <span class="badge bg-warning text-dark">{{ selection2.selected.length }} OP(s) seleccionada(s)</span>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-12">
                <mat-form-field appearance="outline" class="w-100 small-form-field">
                  <mat-label>Buscar polígono...</mat-label>
                  <input matInput [(ngModel)]="busquedaPoligono2">
                  <mat-icon matSuffix *ngIf="busquedaPoligono2" (click)="busquedaPoligono2=''" class="clear-icon">close</mat-icon>
                </mat-form-field>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12">
                <mat-form-field appearance="outline" class="w-100 small-form-field">
                  <mat-label>Nuevo polígono</mat-label>
                  <mat-select [formControl]="poligonoMasivo2Ctrl">
                    <mat-option [value]="null">-- Seleccione --</mat-option>
                    <mat-option *ngFor="let p of poligonosFiltrados2" [value]="p.ID_POLI">
                      {{ p.COD_POLIGONO }} - {{ p.NOMBRE_POLIGONO }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-auto d-flex gap-2">
                <button class="btn btn-warning btn-sm" (click)="asignarMasivo2()">
                  <mat-icon class="small-icon">edit</mat-icon> Modificar
                </button>
                <button class="btn btn-outline-secondary btn-sm" (click)="limpiarMasivo2()">
                  <mat-icon class="small-icon">clear</mat-icon> Limpiar
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Tabla Tab 2 -->
        <div class="card mb-4" *ngIf="dataSource2.data.length > 0 || dataOriginal2.length > 0">
          <div class="card-body p-0">
            <div class="table-responsive">
              <table mat-table [dataSource]="dataSource2" matSort #sort2="matSort" class="w-100 ops-table">

                <ng-container matColumnDef="select">
                  <th mat-header-cell *matHeaderCellDef class="col-check">
                    <mat-checkbox (change)="toggleAll2()"
                                  [checked]="isAllSelected2()"
                                  [indeterminate]="selection2.selected.length > 0 && !isAllSelected2()">
                    </mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let row" class="col-check">
                    <mat-checkbox (click)="$event.stopPropagation()"
                                  (change)="$event ? selection2.toggle(row) : null"
                                  [checked]="selection2.isSelected(row)">
                    </mat-checkbox>
                  </td>
                </ng-container>

                <ng-container matColumnDef="FECHA_PICKING">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha Picking</th>
                  <td mat-cell *matCellDef="let row">{{ formatearFechaDisplay(row.FECHA_PICKING) }}</td>
                </ng-container>

                <ng-container matColumnDef="NUM_ORDEN">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Num. Orden</th>
                  <td mat-cell *matCellDef="let row">{{ row.NUM_ORDEN || '-' }}</td>
                </ng-container>

                <ng-container matColumnDef="PEDIDO_SAP">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Pedido SAP</th>
                  <td mat-cell *matCellDef="let row">{{ row.PEDIDO_SAP || '-' }}</td>
                </ng-container>

                <ng-container matColumnDef="DEPARTAMENTO">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Departamento</th>
                  <td mat-cell *matCellDef="let row">{{ row.DEPARTAMENTO || '-' }}</td>
                </ng-container>

                <ng-container matColumnDef="MUNICIPIO">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Municipio</th>
                  <td mat-cell *matCellDef="let row">{{ row.MUNICIPIO || '-' }}</td>
                </ng-container>

                <ng-container matColumnDef="CODIGO_ZONA_SAP">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Zona SAP</th>
                  <td mat-cell *matCellDef="let row">{{ row.CODIGO_ZONA_SAP || '-' }}</td>
                </ng-container>

                <ng-container matColumnDef="BARRIO">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Barrio</th>
                  <td mat-cell *matCellDef="let row">{{ row.BARRIO || '-' }}</td>
                </ng-container>

                <ng-container matColumnDef="TIPO_ORDEN">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo Orden</th>
                  <td mat-cell *matCellDef="let row">
                    <span class="badge-tipo">{{ row.TIPO_ORDEN || '-' }}</span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="poligono">
                  <th mat-header-cell *matHeaderCellDef>Cambiar Polígono</th>
                  <td mat-cell *matCellDef="let row" class="col-poligono" (click)="$event.stopPropagation()">
                    <div class="d-flex align-items-center gap-1">
                      <mat-form-field appearance="outline" class="poligono-select small-form-field">
                        <mat-select [(ngModel)]="row.poligonoAsignado" placeholder="Cambiar a...">
                          <mat-option [value]="null">-- Sin cambio --</mat-option>
                          <mat-option *ngFor="let p of poligonos" [value]="p.ID_POLI">
                            {{ p.COD_POLIGONO }} - {{ p.NOMBRE_POLIGONO }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <button class="btn btn-warning btn-sm btn-guardar"
                              [disabled]="!row.poligonoAsignado"
                              (click)="guardarIndividual2(row)" title="Guardar cambio">
                        <mat-icon class="small-icon">edit</mat-icon>
                      </button>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="cols2; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: cols2;"
                    [class.row-selected]="selection2.isSelected(row)"
                    (click)="selection2.toggle(row)"></tr>
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell text-center py-3" [attr.colspan]="cols2.length">
                    No se encontraron OPs con los filtros aplicados.
                  </td>
                </tr>
              </table>
            </div>
            <mat-paginator #paginator2 [pageSizeOptions]="[10, 25, 50, 100]"
                           showFirstLastButtons class="paginator-small">
            </mat-paginator>
          </div>
        </div>

        <!-- Estado vacío Tab 2 -->
        <div class="card mb-3" *ngIf="dataSource2.data.length === 0 && dataOriginal2.length === 0">
          <div class="card-body text-center py-5 text-muted">
            <mat-icon class="empty-icon">map</mat-icon>
            <p class="mt-2">Seleccione bodega, polígono y rango de fechas, luego presione <strong>Buscar</strong>.</p>
          </div>
        </div>

      </ng-template>
    </mat-tab>

  </mat-tab-group>
</div>
